export function getDefaultMarketFilter(userMarkets: string[] | undefined | null): string {
  if (!userMarkets || userMarkets.length === 0) {
    return '';
  }
  return userMarkets.join(',');
}
